import { render, staticRenderFns } from "./mapkind-dialog.vue?vue&type=template&id=8a85728c&scoped=true"
import script from "./mapkind-dialog.vue?vue&type=script&lang=js"
export * from "./mapkind-dialog.vue?vue&type=script&lang=js"
import style0 from "./mapkind-dialog.vue?vue&type=style&index=0&id=8a85728c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a85728c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a85728c')) {
      api.createRecord('8a85728c', component.options)
    } else {
      api.reload('8a85728c', component.options)
    }
    module.hot.accept("./mapkind-dialog.vue?vue&type=template&id=8a85728c&scoped=true", function () {
      api.rerender('8a85728c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mutils/views/map-save-action/mapkind-dialog.vue"
export default component.exports